/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/cover.js":
/*!************************************************!*\
  !*** ./zrc/scripts/sections/homepage/cover.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\nclass CoverComponent extends window.HTMLElement {\n  connectedCallback() {\n    this.$sliderElement = this.querySelector('.hc-swiper');\n    this.slidesCount = this.$sliderElement.querySelectorAll('.hc-slide:not(.swiper-slide-duplicate)').length;\n    this.sliderAutoplay = this.$sliderElement.dataset.autoplay === 'true' ? 1 : 0;\n    this.$swiper = null;\n    this.initSwiper();\n    this._loadYoutubeApi();\n  }\n  initSwiper() {\n    this.$swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default(this.$sliderElement, {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Pagination, swiper__WEBPACK_IMPORTED_MODULE_0__.Autoplay],\n      loop: this.slidesCount > 1,\n      autoplay: {\n        enabled: this.sliderAutoplay === 1,\n        delay: this.$sliderElement.dataset.autoplayDelay * 1000 * this.sliderAutoplay,\n        disableOnInteraction: false\n      },\n      pagination: {\n        el: '.swiper-pagination',\n        clickable: true\n      }\n    });\n  }\n  _loadYoutubeApi() {\n    // https://www.youtube.com/iframe_api\n    // Mandamos a llamamar dinamicamente la api de youtube\n\n    const $scriptYoutube = document.getElementById('youtubeIframeScripts');\n    if ($scriptYoutube == null) {\n      const scriptYoutubeApi = document.createElement('script');\n      scriptYoutubeApi.id = 'youtubeIframeScripts';\n      scriptYoutubeApi.src = 'https://www.youtube.com/iframe_api';\n      document.head.appendChild(scriptYoutubeApi);\n    }\n    window.onYouTubeIframeAPIReady = this._loadYoutubeVideos.bind(this);\n  }\n  _loadYoutubeVideos() {\n    this.externalVideoSlides = this.querySelectorAll('.hc-external-video');\n    if (this.externalVideoSlides === 0) {\n      return;\n    }\n    this.externalVideoSlides.forEach($videoWrapper => {\n      if (window.YT == null) {\n        return;\n      }\n\n      // Obtenemos el ID del video y el nodo padre\n      const videoID = $videoWrapper.dataset.mediaId;\n      new window.YT.Player($videoWrapper, {\n        videoId: videoID,\n        playerVars: {\n          autoplay: 1,\n          mute: 1,\n          loop: 1,\n          playlist: videoID,\n          controls: 0,\n          showinfo: 0,\n          modestbranding: 1,\n          rel: 0,\n          fs: 0,\n          iv_load_policy: 3,\n          disablekb: 1,\n          origin: window.location.origin\n        }\n      });\n    });\n  }\n}\nwindow.customElements.define('cover-component', CoverComponent);//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/cover.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"homepage-cover": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/cover.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;